import { ZodError } from 'zod';

import { ApiError } from '@/lib/api-client.ts';

import { MetricFailureReason } from '@/models/metrics.ts';

/**
 * The availability services throw a 502 carrying the `ZodError` when a response failed its schema.
 * The status alone is not enough: the shared API client turns an upstream 502 into the same status.
 */
export const toAvailabilityFailureReason = (error: unknown): MetricFailureReason =>
    error instanceof ApiError && error.data instanceof ZodError
        ? 'availability_invalid_response'
        : 'availability_request_failed';
